import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-24 pb-12 overflow-hidden" data-id="element-106">
      {/* Background ambient glow */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gold-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-107" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-12 lg:gap-8 items-center relative z-10" data-id="element-108">
        <div className="order-2 lg:order-1 flex flex-col items-start text-left" data-id="element-109">
          <FadeIn delay={0.1} data-id="element-110">
            <div className="inline-block border border-gold-500/30 px-4 py-1.5 rounded-full text-gold-400 text-xs font-semibold tracking-widest uppercase mb-6 bg-navy-800/50 backdrop-blur-sm" data-id="element-111">
              El Despertar
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-112">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] mb-6" data-id="element-113">
              Mañana puede ser igual, o puede ser el inicio de{' '}
              <span className="text-gradient-gold italic" data-id="element-114">tu imperio.</span>
            </h1>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-115">
            <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-xl leading-relaxed font-light" data-id="element-116">
              Te han dicho que el sueño americano es trabajar duro. Te
              mintieron. El sueño americano es invertir con inteligencia. No
              dejes que pase otro año siendo solo un espectador.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-117">
            <Button showArrow onClick={() => document.getElementById('precio')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-118">
              Obtener El Código
            </Button>
            <Button variant="secondary" onClick={() => document.getElementById('precio')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-119">
              Ver Cómo Funciona
            </Button>
          </FadeIn>
        </div>

        <FadeIn delay={0.5} direction="left" className="order-1 lg:order-2 relative" data-id="element-120">
          <div className="relative w-full max-w-2xl mx-auto" data-id="element-121">
            {/* Subtle glow behind image */}
            <div className="absolute inset-0 bg-gold-500/10 blur-[60px] rounded-full" data-id="element-122" />
            <img src="https://cdn.magicpatterns.com/uploads/puwmM59rgE1FXWvhvq1jbx/EL_CODIGO_DE_LA_RIQUEZA.png" alt="El Código de la Riqueza Latina - portada del libro y programa en dispositivos" className="relative z-10 w-full h-auto drop-shadow-2xl transform hover:scale-[1.02] transition-transform duration-700" data-id="element-123" />
          </div>
        </FadeIn>
      </div>
    </section>;
}